import { render, staticRenderFns } from "./CTErrors.UK.vue?vue&type=template&id=3cbf73bc&scoped=true"
import script from "./CTErrors.UK.vue?vue&type=script&lang=js"
export * from "./CTErrors.UK.vue?vue&type=script&lang=js"
import style0 from "./CTErrors.UK.vue?vue&type=style&index=0&id=3cbf73bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf73bc",
  null
  
)

export default component.exports